$(function(){
  console.log('hello world');
  // openGameWidget();
  if ($(window).width() < 500) {
    initStoreMessagesSlider();
  }
  initDate();
  cartJSEvent();
  masterPromo(false);
  onLoadCookieBar();
  onloadWishlist();
  onloadImgColor();
  initSliderTabs();
  onloadCustomRowBgVideo();
  getTaxAttr();
  openChatFromPageFly();
  initFeatrueCollectionSlider();
  removeOneCardError();
  initPdpHighlightSlider();
  playVideoInSequence();
  updateHighlightPopupPosition();

  $(window).on('resize', function() {
    initPdpHighlightSlider();
    updateHighlightPopupPosition();
  });

});

openGameWidget = () =>{
  var $widget = $('.rhym-float-widget');

  if ($widget.length > 0 && !sessionStorage.getItem('gameWidgetOpened')) {
    $widget.click();
    sessionStorage.setItem('gameWidgetOpened', 'true');
  }
}

onloadCustomRowBgVideo = () =>{
  var isFollowImageHeight = $('.isFollowImageHeight').val();
  var isImageSectionExist = $('.jsc-reset-height--adapt');
  if ((isFollowImageHeight) && (isImageSectionExist.length > 0)) {
    var height = isImageSectionExist.height();
    $('.jsc-reset-height-video-container--background').css('height',height);
  }

  $( window ).resize(function() {
    if ((isFollowImageHeight) && (isImageSectionExist.length > 0)) {
      var height = isImageSectionExist.height();
      $('.jsc-reset-height-video-container--background').css('height',height);
    }
  });
}

initSliderTabs = () =>{

  if ($(window).width() < 500) {
    $('.jsc-slider-text-tabs').slick({
      dots: false,
      slidesToShow: 2,
      focusOnSelect: true,
      infinite: false
    });
  }else if ($(window).width() <= 820) {
    $('.jsc-slider-text-tabs').slick({
      dots: false,
      slidesToShow: 3,
      focusOnSelect: true,
      infinite: false
    });
  }else{
    $('.jsc-slider-text-tabs').slick({
      dots: false,
      slidesToShow: 6,
      focusOnSelect: true,
      infinite: false
    });
  }
}

setCookies = (cname,cval,days) =>{
  const d = new Date();
  d.setTime(d.getTime() + (days*24*60*60*1000));

  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cval + ";" + expires + ";path=/";
}

getCookies = (cname) =>{
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

acceptCookies = (e) =>{
  var $this = $(e);

  $this.parents('.jsc-cookies-container').hide();

  setCookies('jsc-accept-cookie', true, 120);
}

onLoadCookieBar = () =>{
  var isAccpet = getCookies('jsc-accept-cookie') === 'true';
  if (isAccpet) {
    $('.jsc-cookies-container').hide();
  }
  else {
    $('.jsc-cookies-container').removeClass('d-none');
  }
}

initStoreMessagesSlider = () =>{
  $('.jsc-mobile-slider').slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  });
}

validateUpdate = ($first_name, $last_name, $telephone, $birthday) =>{
  var $isError = true;

  if ($first_name == '') {
    $('#first_name_error').show();
    $isError = false;
  } else {
    $('#first_name_error').hide();
  }
  if ($last_name == '') {
    $('#last_name_error').show();
    $isError = false;
  } else {
    $('#last_name_error').hide();
  }
  if ($telephone == '') {
    $('#telephone_error').show();
    $isError = false;
  } else {
    if ($telephone.length == 10) {
      $isError = true;
      $('#telephone_valid').hide();
    } else {
      $isError = false;
      $('#telephone_valid').show();
    }
    $('#telephone_error').hide();
  }
  if ($birthday == '') {
    $('#birthday_error').show();
    $isError = false;
  } else {
    $('#birthday_error').hide();
  }

  return $isError;
}

updatePdpa = (evt) =>{
  var $loader = $('.jsc-loader-overlay');
  $loader.show();
  var $this = $(evt);
  var $id = parseInt($('#jsc-customer-pdpa-id').val());
  var $idList = $('#jsc-customer-pdpa-id-list').val();
  var $shopifyId = parseInt($('#jsc-customer-id').val());
  var $first_name = $('#jsc-first_name').val();
  var $last_name = $('#jsc-last_name').val();
  var $email = $('#jsc-register_email').val();
  var $telephone = $('#jsc-register_mobile').val();
  var $birthday = $('#jsc-birthday').val();
  var $province = $('#jsc-province').val();
  var $gender = $('#jsc-gender').val();
  var $isvalidated = validateUpdate($first_name, $last_name, $telephone, $birthday);

  var $oldTel = $('#jsc-customter-old-tel').val();
  var $oldBirth = $('#jsc-customter-old-birth').val();
  var $oldProvince = $('#jsc-customter-old-province').val();
  var $oldGender = $('#jsc-customter-old-gender').val();
  var $isConsent = $('#jsc-accepts_marketing').prop('checked');
  var $oldPdpa = $isConsent ? '__pdpa:false' : '__pdpa:true';
  var $newPdpa = $isConsent ? '__pdpa:true' : '__pdpa:false';

  if($gender == 'Male'){
    $gender = 'ชาย';
  } else if($gender == 'Female'){
    $gender = 'หญิง';
  } else if($gender == 'Others'){
    $gender = 'อื่นๆ';
  }

  var $isId = isNaN($id);

  if ($isvalidated) {
    if ($isConsent || $isId) {
      var webhook = 'https://webhooks.mechanic.dev/fd3f79c1-17bc-4dd0-badc-cbeee3b8dda7'; // user/update_pdpa/one
      if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
        $gender = '';
      }
  
      let $data = {
        first_name: $first_name,
        last_name: $last_name,
        birthday: $birthday,
        email: $email,
        telephone: $telephone,
        province: $province,
        gender: $gender,
        isConsent: $isConsent,
        shopify_customer_id: $shopifyId,
        old_tel: $oldTel,
        old_brith: $oldBirth,
        old_pro: $oldProvince,
        old_gen: $oldGender,
        old_pdpa: $oldPdpa,
        pdpa: $newPdpa
      };
      $.ajax({
        url: webhook,
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify($data)
      }).done(function () {
        setTimeout(function(){
          $loader.hide();
          location.reload();
        },24000);
      });
    } else {
      var webhook_2 = 'https://webhooks.mechanic.dev/162359e7-365b-4469-9f09-4adbc904af83'; // user/update_pdpa/two
      if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
        $gender = '';
      }
  
      let $data = {
        id: $id,
        first_name: $first_name,
        last_name: $last_name,
        birthday: $birthday,
        email: $email,
        telephone: $telephone,
        province: $province,
        gender: $gender,
        isConsent: $isConsent,
        shopify_customer_id: $shopifyId,
        old_tel: $oldTel,
        old_brith: $oldBirth,
        old_pro: $oldProvince,
        old_gen: $oldGender,
        old_pdpa: $oldPdpa,
        pdpa: $newPdpa
      };
      $.ajax({
        url: webhook_2,
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify($data)
      }).done(function () {
        setTimeout(function(){
          $loader.hide();
          location.reload();
        },24000);
      });
    }
  } else {
    $loader.hide();
  }
}

checkSubscriptionMarketing = (evt) =>{
  var $this = $(evt);
  var $isConsent = $this.prop('checked');
  var $submitButton = $('#subscription-submit');

  console.log('checkSubscriptionMarketing - $isConsent: ', $isConsent);

  if ($isConsent) {
      $submitButton.removeClass('disabled-submit');
  } else {
      $submitButton.addClass('disabled-submit');
  }
}

submitSubscriptionPdpa = (evt) =>{
  var $this = $(evt);
  var $id = parseInt($('#jsc-customer-pdpa-id').val());
  var $idList = $('#jsc-customer-pdpa-id-list').val();
  var $shopifyId = parseInt($('#jsc-customer-id').val()) || "";
  var $first_name = $('#jsc-first_name').val();
  var $last_name = $('#jsc-last_name').val();
  var $email = $('#jsc-register_email').val();
  var $telephone = $('#jsc-register_mobile').val();
  var $birthday = $('#jsc-birthday').val();
  var $province = $('#jsc-province').val();
  var $gender = $('#jsc-gender').val();
  var $isvalidated = validateUpdate($first_name, $last_name, $telephone, $birthday);

  var $oldTel = $('#jsc-customter-old-tel').val();
  var $oldBirth = $('#jsc-customter-old-birth').val();
  var $oldProvince = $('#jsc-customter-old-province').val();
  var $oldGender = $('#jsc-customter-old-gender').val();
  var $isConsent = $('#jsc-accepts_marketing').prop('checked');
  var $oldPdpa = $isConsent ? '__pdpa:false' : '__pdpa:true';
  var $newPdpa = $isConsent ? '__pdpa:true' : '__pdpa:false';

  var $subscriptionTag = $('#jsc-subscription-tag').val();
  console.log('submitSubscriptionPdpa - shopifyId: ', $subscriptionTag);

  if($gender == 'Male'){
    $gender = 'ชาย';
  } else if($gender == 'Female'){
    $gender = 'หญิง';
  } else if($gender == 'Others'){
    $gender = 'อื่นๆ';
  }

  var emailDOM = $('#jsc-register_email')[0];
  // console.log('emailDOM.checkValidity(): ', emailDOM.checkValidity());
  if ($email == '') {
    $isvalidated = false;
    $('#email_error').show();
  } else {
    $('#email_error').hide();
    if (!emailDOM.checkValidity()) {
      $isvalidated = false;
      $('#email_invalid_error').show();
    } else {
      $('#email_invalid_error').hide();
    }
  }

  var $isId = isNaN($id);

  if ($isvalidated) {
    let mechanicWebhook = '';
    if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
      $gender = '';
    }
    let $data = {
      first_name: $first_name,
      last_name: $last_name,
      birthday: $birthday,
      email: $email,
      telephone: $telephone,
      province: $province,
      gender: $gender,
      isConsent: $isConsent,
      shopify_customer_id: $shopifyId,
      old_tel: $oldTel,
      old_brith: $oldBirth,
      old_pro: $oldProvince,
      old_gen: $oldGender,
      old_pdpa: $oldPdpa,
      pdpa: $newPdpa,
      subscription_tag: $subscriptionTag
    };

    if ($shopifyId == '') {
      mechanicWebhook = 'https://webhooks.mechanic.dev/945f1af3-31d5-4ff4-8601-99a9dd8765c3'; // user/subscription_form/submit
    } else if ($isConsent || $isId) {
      mechanicWebhook = 'https://webhooks.mechanic.dev/fd3f79c1-17bc-4dd0-badc-cbeee3b8dda7'; // user/update_pdpa/one
    } else {
      mechanicWebhook = 'https://webhooks.mechanic.dev/162359e7-365b-4469-9f09-4adbc904af83'; // user/update_pdpa/two
      $data.id = $id;
    }
    $.ajax({
      url: mechanicWebhook,
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    }).done(function () {
      console.log('submitSubscriptionPdpa: ', $('#jsc-subscription-form__container'));
      if ($('#jsc-thank-you__container').length) {
          $('#jsc-thank-you__container').css('display', 'block');
          $('#jsc-subscription-form__container').css('display', 'none');
      }
    });
  } else {
    console.log('submitSubscriptionPdpa validation failed: ', $('#jsc-subscription-form__container'));
    if ($('#jsc-thank-you__container').length) {
        $('#jsc-thank-you__container').css('display', 'none');
        $('#jsc-subscription-form__container').css('display', 'flex');
    }
  }
}

validateRegister = ($first_name, $last_name, $email, $telephone, $birthday, $password) =>{
  var $isError = true;

  if ($first_name == '') {
    $('#first_name_error').show();
    $isError = false;
  } else {
    $('#first_name_error').hide();
  }
  if ($last_name == '') {
    $('#last_name_error').show();
    $isError = false;
  } else {
    $('#last_name_error').hide();
  }
  if ($email == '') {
    $('#email_error').show();
    $isError = false;
  } else {
    $('#email_error').hide();
  }
  if ($telephone == '') {
    $('#telephone_error').show();
    $isError = false;
  } else {
    $('#telephone_error').hide();
    if ($telephone.length != 10) {
      $('#telephone_valid').show();
      $isError = false;
    } else {
      if ($telephone.slice(0,1) != '0') {
        $('#telephone_valid').show();
        $isError = false;
      }else {
        $('#telephone_valid').hide();
      }
    }
  }
  if ($birthday == '') {
    $('#birthday_error').show();
    $isError = false;
  } else {
    $('#birthday_error').hide();
  }
  if ($password == '') {
    $('#password_error').show();
    $isError = false;
  } else {
    $('#password_error').hide();
  }

  return $isError;
}

pdpaConsent = (evt) =>{
  var $loader = $('.jsc-loader-overlay');
  $loader.show();
  var $this = $(evt);
  var $form = $('#create_customer');
  var $first_name = $form.find('input[name="customer[first_name]"]').val();
  var $last_name = $form.find('input[name="customer[last_name]"]').val();
  var $email = $form.find('input[name="customer[email]"]').val();
  var $telephone = $form.find('input[name="telephone"]').val();
  var $birthday = $form.find('input[name="birthday"]').val();
  var $isConsent = $form.find('#jsc-accepts_marketing').prop('checked');
  var $password = $form.find('input[name="customer[password]"]').val();
  var $isvalidated = validateRegister($first_name, $last_name, $email, $telephone, $birthday, $password);


  setTimeout(function(){
    if ($isvalidated) {
      $('#jsc-customer-tag').val('__tel:'+$telephone+',__birthday:'+$birthday+',__pdpa:'+$isConsent);
      $this.siblings('.jsc-register-btn').click();
    }
    $loader.hide();
  },1800);
}

initDate = () =>{
  console.log('fannnnnn');
  var startDate = new Date(1900, 1 - 1, 1);
  var currentDate = new Date();
  var endDate = new Date(new Date().getFullYear() - 10, currentDate.getMonth(), currentDate.getDate());
  $('#jsc-birthday').datepicker({
    format: 'yyyy-mm-dd',
    startDate: startDate,
    endDate: endDate,
    startView: 2,
    maxViewMode: 2
  });
}

//Start CartJS Function

cartJSEvent = () => {
  $(document).on('cart.requestComplete', function(event, cart) {
    document.documentElement.dispatchEvent(
    new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
  });
}

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}
//End CartJS Function

//Start Master Promo Function
masterPromo = (isDrawer) =>{
  /*
  setTimeout(function(){
  */
    tierFunction(isDrawer);
    gwpFunction(isDrawer);
    cartGift();
    removeBundleOnThemeSettings();
    pwpSetValidationCart();
    updateTolimitbundle();
    cartGiftProperties();
  /*
  },1000);
  */
}

//Start - Gift properties apps
cartGiftProperties = () =>{
  $('.jsc-update-gwp-apps').each(function(){
    var $key = parseInt($(this).val());
    var $qty = parseInt($(this).attr('data-qty'));
    var $gwpcart_product = {};
    $gwpcart_product['_Cart_GWP'] = 'Free Gift';
    cartJSUpdateQuery($key, $qty, $gwpcart_product);
  });
}
//End - Gift properties apps
//Start GWP promo
gwpFunction = (isOpenDrawer) =>{
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
    var $gwpcart_product = {};
    var $addEle = $('.jsc-add-gwp');
    var $updateEle = $('.jsc-update-gwp');
    var $deleteEle = $('.jsc-remove-gwp');

    $gwpcart_product['_Promo'] = 'Free Gift';

    $addEle.each(function() {
      var $vid = parseInt($(this).val());
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      console.log('test');

      cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $updateEle.each(function() {
      var $vid = $(this).val();
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $deleteEle.each(function() {
      var $vid = $(this).val();
      var $qty = 0;

      cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
    });

  });
}
//End GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

addCartGift = () =>{
  var $elem = $('#jsc-cart-gift');
  var $vid = $elem.val();
  var $obj = {};
  var $promoNo = $elem.attr('data-promo');

  $obj['_Cart_Gift'] = $promoNo;
  $obj['_Cart_GWP'] = 'Free Gift';
  if ($elem.length > 0) {
    cartJSAddQuery($vid,1,$obj,true);
  }
  $('.jsc-cart-gift-upt').each(function () {
    $loader.show();
    var $vid = $(this).val();
    var $qty = parseInt($(this).attr('data-qty'));

    var $obj = {};
    var $promoNo = $(this).attr('data-promo');
    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';

    cartJSUpdateQuery($vid, $qty, $obj, false);
  });
}

removeCartGift = () =>{
  var $elem = $('#jsc-cart-gift-remove');
  var $key = $elem.val();

  if ($elem.length > 0) {
    cartJSUpdateQuery($key, 0, {}, true);
  }
}
//End GWP based on cart, product or collection promo
//Start tier discount promo
tierFunction = (isOpenDrawer) =>{
  var $updateEle = $('.jsc-tier-product');
  var $removeEle = $('.jsc-tier-product-remove');

  $updateEle.each(function(){
    var $obj = {};
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $discountVal = $this.val();
    var $discountType = $this.attr('data-discount-type');
    var $tierNo = $this.attr('data-promo-no');
    var $qty = parseInt($this.attr('data-qty'));

    $obj['_Quantity-Promo'] = $discountType;
    $obj['_Off-Value'] = $discountVal;
    $obj['_Promo-no'] = $tierNo;
    $obj['_Tier'] = true;

    cartJSUpdateQuery($key, $qty, $obj, isOpenDrawer);
  });

  $removeEle.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var $promoNo = $this.attr('data-promo-no');
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisKey == $key && $thisProps['_Promo-no'] == $promoNo) {
          delete $thisProps['_Quantity-Promo'];
          delete $thisProps['_Off-Value'];
          delete $thisProps['_Promo-no'];
          delete $thisProps['_Tier'];

          var $isEmptyProperty = $.isEmptyObject($thisProps);
          if ($isEmptyProperty) {
            // if properties is empty then, remove the product and add back
            replaceProduct($thisKey, $vID, $thisQty, isOpenDrawer);
          } else {
            // if properties not empty then, just update the properties
            cartJSUpdateQuery($thisKey, $thisQty, $thisProps, isOpenDrawer);
          }
        }
      }
    });
  });
}

replaceProduct = ($key, $vid, $qty, isOpenDrawer) =>{
  CartJS.removeItemById($key,
  {
    "success": function(data, textStatus, jqXHR) {
      cartJSAddQuery($vid, $qty, {}, isOpenDrawer);
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}
//End tier discount promo
//Start variant selected in pdp for bundle and pwp
variantOption = (evt, index, setValue) =>{
  var $this = $(evt);
  var $thisImgUrl = $this.find(':selected').attr('data-img');
  var $thisVid = $this.val();
  var $thisPrice = $this.find(':selected').attr('data-price');
  var $thisTitle = $this.find(':selected').text();
  var $thisComparePrice = $this.find(':selected').attr('data-compare-price');
  var $isDiscounted = $this.find(':selected').attr('data-settings-discount') == 'true';
  var $currencyFormat = $('html').attr('data-currency');
  var $variantTitleEle = $this.parent().find('span.jsc-variant-title');

  var $hiddenEle = $this.parents('.jsc-container').find('.jsc-hidden');
  var $discountType = $hiddenEle.val();
  var $minusPrice = $discountType == 'percentage-off' ? parseFloat($hiddenEle.attr('data-'+$discountType+'-'+index)) : parseInt($hiddenEle.attr('data-'+$discountType+'-'+index));

  // update image
  $this.parent().find('img').attr('src', $thisImgUrl);

  // update price
  if ($isDiscounted) { // if discount value is not empty in theme settings, then calculate the price
    var $discountedValue = 0;
    if ($discountType == 'percentage-off') {
      $discountedValue = $thisPrice * $minusPrice;
    } else {
      $discountedValue = $thisPrice - $minusPrice;
    }

    var price = $thisComparePrice;
    var discountprice = $thisPrice;

    $this.siblings('.jsc-price').find('strike').text(price);
    $this.siblings('.jsc-price').find('span').text(discountprice);
  } else { // if discount value is empty in theme settings, then show normal price
    if ($thisComparePrice) {
      var comparePrice = $thisComparePrice;
      $this.siblings('.jsc-price').find('strike').text(comparePrice);
      $this.siblings('.jsc-price').find('strike').show();
    } else {
      $this.siblings('.jsc-price').find('strike').hide();
    }
    var price = $thisPrice;
    $this.siblings('.jsc-price').find('span').text(price);
  }

  // update variant ID
  $this.parent().attr('data-vid', $thisVid);

  // This function is to hide atc btn and show limit message if pwp reached the set limit
  if (setValue) {
    pwpSetValidationPdp(setValue, $this);
  }

  if ($variantTitleEle.length > 0) {
    $variantTitleEle.html($thisTitle);
  }
}
//End variant selected in pdp for bundle and pwp

//Start PWP promo
pwpAddToCart = (evt,discount2, discountType, index) =>{
  var $this = $(evt);
  var properties1 = {};
  var properties2 = {};
  var vid1 = parseInt($this.parent().find('.jsc-pwp-col-1').attr('data-vid'));
  var vid2 = parseInt($this.parent().find('.jsc-pwp-col-2').attr('data-vid'));
  var $bindId = vid1+'-'+vid2;


  properties1['_PWP'] = 'Master';
  properties1['_BindID'] = $bindId;
  properties1['_Promo-No'] = index;


  properties2['_Quantity-Promo'] = discountType;
  properties2['_Off-Value'] = discount2;
  properties2['_PWP'] = 'Child';
  properties2['_BindID'] = $bindId;
  properties2['_Promo-No'] = index;

  cartJSAddQuery(vid1, 1, properties1, true);
  cartJSAddQuery(vid2, 1, properties2, true);
  /*
  $(document).on('cart.requestComplete', function(event, cart) {
    setTimeout(function(){
      masterPromo(false);
    },500);
  });
  */
}

removePwp = (evt, bindid, pwp) =>{
  setTimeout(function(){
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisProps['_BindID'] == bindid) {

          if (pwp == 'Master') {
            // if customer remove master product we remove the child product
            cartJSUpdateQuery($thisKey, 0, {}, true);
          } else if (pwp == 'Child') {
            // if customer remove child product we keep the master product, but remove the pwp properties
            delete $thisProps['_Quantity-Promo'];
            delete $thisProps['_Off-Value'];
            delete $thisProps['_BindID'];
            delete $thisProps['_PWP'];
            delete $thisProps['_Promo-No'];

            var $isEmptyProperty = $.isEmptyObject($thisProps);
            if ($isEmptyProperty) {
              // if properties is empty then, remove the product and add back
              replaceProduct($thisKey, $vID, $thisQty, true);
            } else {
              // if properties not empty then, just update the properties
              cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
            }
          }
        }
      }
    });
  },900);
  $(document).on('cart.requestComplete', function(event, cart) {
    pwpSetValidationCart();
  });
}

updatePwp = (evt,bindid) =>{
  setTimeout(function(){
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        $thisQty -= 1;
        if ($thisProps['_BindID'] == bindid && $thisProps['_PWP'] == 'Child') {
          cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
          console.log('slow333', $thisQty);
        }
      }
    });
  },900);
}

pwpSetValidationPdp = (setValue, $this) =>{
  var $v1 = $this.parents('.jsc-container').find('.jsc-pwp-col-1').attr('data-vid');
  var $v2 = $this.parents('.jsc-container').find('.jsc-pwp-col-2').attr('data-vid');
  var $bId = $v1+'-'+$v2;
  var $isInCart = false;
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $items = cart.items;
    for (var i = 0; i < $items.length; i++) {
      var $thisQty = $items[i].quantity;
      var $thisProps = $items[i].properties;

      if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
        if ($thisQty >= setValue) { // if pwp variant have reached set limit
          $this.parents('.jsc-container').find('.jsc-set-limit-msg').show();
          $this.parents('.jsc-container').find('.jsc-atc-btn').hide();
        } else { // if pwp variant not yet reached set limit
          $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
          $this.parents('.jsc-container').find('.jsc-atc-btn').show();
        }
        $isInCart = true;
      }
    }

    // if variant is not in cart
    if (!$isInCart) {
      $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
      $this.parents('.jsc-container').find('.jsc-atc-btn').show();
    }
  });
}

pwpSetValidationCart = () =>{
  var $pwpContainer = $('.jsc-pwp-container');

  $pwpContainer.each(function(){
    var $this = $(this);
    var $v1 = $this.find('.jsc-pwp-col-1').attr('data-vid');
    var $v2 = $this.find('.jsc-pwp-col-2').attr('data-vid');
    var $bId = $v1+'-'+$v2;
    var $isInCart = false;
    var $setValue = parseInt($this.attr('data-set'));

    if ($setValue) {
      $.when($.getJSON('/cart.js')).then(function(cart){
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
          var $thisQty = $items[i].quantity;
          var $thisProps = $items[i].properties;

          if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
            if ($thisQty >= $setValue) { // if pwp variant have reached set limit
              $this.find('.jsc-set-limit-msg').show();
              $this.find('.jsc-atc-btn').hide();
            } else { // if pwp variant not yet reached set limit
              $this.find('.jsc-set-limit-msg').hide();
              $this.find('.jsc-atc-btn').show();
            }
            $isInCart = true;
          }
        }
        // if variant is not in cart
        if (!$isInCart) {
          $this.find('.jsc-set-limit-msg').hide();
          $this.find('.jsc-atc-btn').show();
        }
      });
    }
  });
}
//End PWP promo

//Start bundle promo
bundleAddToCart = (evt,discount1,discount2, discountType, i) =>{
  var $this = $(evt);
  var properties1 = {};
  var properties2 = {};
  var vid1 = parseInt($this.parent().find('.jsc-bundle-col-1').attr('data-vid'));
  var vid2 = parseInt($this.parent().find('.jsc-bundle-col-2').attr('data-vid'));
  var $bindId = vid1+'-'+vid2;


  properties1['_Quantity-Promo'] = discountType;
  properties1['_Off-Value'] = discount1;
  properties1['_Bundle'] = true;
  properties1['_BindID'] = $bindId;
  properties1['_Promo-no'] = i;

  properties2['_Quantity-Promo'] = discountType;
  properties2['_Off-Value'] = discount2;
  properties2['_Bundle'] = true;
  properties2['_BindID'] = $bindId;
  properties2['_Promo-no'] = i;

  cartJSAddQuery(vid1, 1, properties1, true);
  cartJSAddQuery(vid2, 1, properties2, true);
  /*
  $(document).on('cart.requestComplete', function(event, cart) {
    setTimeout(function(){
      masterPromo(false);
    },500);
  });
  */
}

updateTolimitbundle = () =>{
  var $uptEle = $('.jsc-update-bundle-fix');
  $uptEle.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var discountType = $this.attr('data-discType');
    var discount = $this.attr('data-offvalue');
    var $bindId = $this.attr('data-bindId');
    var i = $this.attr('data-promo');
    var $thisQty = $this.attr('data-qty');
    var properties = {};
    properties['_Quantity-Promo'] = discountType;
    properties['_Off-Value'] = discount;
    properties['_Bundle'] = true;
    properties['_BindID'] = $bindId;
    properties['_Promo-no'] = i;
    properties['_Limit-Discount'] = true;
    cartJSUpdateQuery($key, $thisQty, properties, true);
  });
}

removeBundle = (evt, bindid, key) =>{
  cartJSUpdateQuery(key, 0);
  $(document).on('cart.requestComplete', function(event, cart) {
    bundleCartAjax(bindid);
  });
}

removeBundleOnThemeSettings = () =>{
  var $removeEle = $('.jsc-remove-bundle');

  $removeEle.each(function(){
    var $this = $(this);
    var $bindId = $this.val();
    var $container = $('.'+$this.attr('data-container'));

    if ($container.length > 0) {
      $container.hide();
    }

    setTimeout(function(){
      bundleCartAjax($bindId);
    },900);
  })

}

bundleCartAjax = (bindid) =>{
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $items = cart.items;
    for (var i = 0; i < $items.length; i++) {
      var $thisKey = $items[i].key;
      var $thisQty = $items[i].quantity;
      var $thisProps = $items[i].properties;
      var $vID = parseInt($items[i].variant_id);

      if ($thisProps['_BindID'] == bindid) {
        delete $thisProps['_Quantity-Promo'];
        delete $thisProps['_Off-Value'];
        delete $thisProps['_Bundle'];
        delete $thisProps['_BindID'];
        delete $thisProps['_Promo-no'];

        var $isEmptyProperty = $.isEmptyObject($thisProps);
        if ($isEmptyProperty) {
          // if properties is empty then, remove the product and add back
          replaceProduct($thisKey, $vID, $thisQty, true);
        } else {
          // if properties not empty then, just update the properties
          cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
        }
      }
    }
  });
}
//End bundle promo

wishList = (e) =>{
  var $this = $(e);
  var $productJson = $this.attr('data-wishjson');
  var $obj = JSON.parse($productJson);
  var $isRemove = $this.hasClass('swym-added');

  if ($isRemove) {
    window._swat.removeFromWishList(
      {
        "epi": $obj.epi,
        "empi": $obj.empi,
        "du": `${$obj.du}`,
        "iu": `${$obj.iu}`,
        "pr": $obj.pr,
        "stk": $obj.stk,
        "variants": `${$obj.variants}`
      },
      function(r) {
        $this.removeClass('swym-added');
        $('.jsc-product_'+$obj.empi).removeClass('swym-added');
      }
    );
  } else {
    window._swat.addToWishList(
      {
        "epi": $obj.epi,
        "empi": $obj.empi,
        "du": `${$obj.du}`,
        "iu": `${$obj.iu}`,
        "pr": $obj.pr,
        "stk": $obj.stk,
        "variants": `${$obj.variants}`
      },
      function(r) {
        $this.addClass('swym-added');
        $('.jsc-product_'+$obj.empi).addClass('swym-added');
      }
    );
  }
}

onloadWishlist = () =>{
  if (!window.location.pathname.includes('/collections/')) {
    setTimeout(function(){
      window._swat.fetch( function(r) {
        for (var i = 0; i < r.length; i++) {
          var $pId = r[i].empi;
          $('.jsc-product_'+$pId).addClass('swym-added');
        }
      });
    },6000);
  }
}

onloadImgColor = () =>{
  if ($(window).width() > 767) {
    desktopOnloadImgColor();
  } else {
    mobileOnloadImgColor();
  }
}

mobileOnloadImgColor = () =>{
  if ($('.jsc-is-color').length) {
    $('.jsc-default-slider').remove();

    var $selectedColor = $('.jsc-color-option:checked').val();
    var $imgs = $('.jsc-hidden-media');

    if (typeof $selectedColor !== 'undefined') {

      $imgs.each(function(){
        var $_this = $(this);
        var $_color = $_this.attr('data-alt');
        var $_videoUrl = $_this.attr('data-video');
        var $_videoThumbnailUrl = $_this.attr('data-video-thumbnail');
        var $_imgUrl = $_this.val();

        if ($_color.includes(",")) {
          $_color = $_color.split(",")[0];
        }
        if ($_color == $selectedColor || $_color == 'Main Image') {
          if($_imgUrl != undefined && $_imgUrl != ""){
            // Main Images
            var $html = '';
            $html = `<div class="slide">
              <a class="show-gallery" href="${$_imgUrl}">
                <div class="rimage-outer-wrapper">
                  <img class="rimage__image lazyload fade-in"
                  data-src="${$_imgUrl}"
                  data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                  data-aspectratio="1.0"
                  data-sizes="auto"
                  alt="${$_color}"
                  >
                </div>
              </a>
            </div>`;
            $('.jsc-gallery__inner .product-slideshow').append($html);

            // Thumbnail Images
            var $thumbHtml = '';
            $thumbHtml = `<div class="jsc-thumbnail-wrapper relative">
                <img class="rimage__image lazyload fade-in"
                data-src="${$_imgUrl}"
                data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                data-aspectratio="1.0"
                data-sizes="auto"
                alt="${$_color}"
                >
              </div>`;
            $('.jsc-mobile-image-wrapper .jsc-thumbnails').append($thumbHtml);
          }
        }
        if (($_videoUrl != undefined && $_videoUrl != "") && ($_videoThumbnailUrl != undefined && $_videoUrl != "")){
          var $_cleanURL = $_videoUrl.split('?')[0];
          if ($_cleanURL.toLowerCase().endsWith(".mp4")) {

            var $html = '';
            $html = `<video controls autoplay muted loop>
                      <source src="${$_videoUrl}" type="video/mp4">
                    </video>`;
            $('.jsc-gallery__inner .product-slideshow').append($html);

          // Thumbnail Images
          var $thumbHtml = '';
          $thumbHtml = `<div class="jsc-thumbnail-wrapper relative">
              <img class="rimage__image lazyload fade-in"
              data-src="${$_videoThumbnailUrl}"
              data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
              data-aspectratio="1.0"
              data-sizes="auto"
              alt="${$_color}"
              >
            </div>`;
          $('.jsc-mobile-image-wrapper .jsc-thumbnails').append($thumbHtml);
          }
        }
      });

      // init main img slider
      $('.jsc-mobile-slider-init').slick('unslick');

      $('.jsc-mobile-slider-init').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.jsc-thumbnails',
        infinite: false,
        dots: true,
        centerMode: false,
        focusOnSelect: true,
        customPaging: function customPaging(slider, i) {
          return "<button class=\"custom-dot\" type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\">" + "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" xml:space=\"preserve\">" + "<circle class=\"circle-one\" cx=\"15\" cy=\"15\" r=\"13\" />" + "<circle class=\"circle-two\" cx=\"15\" cy=\"15\" r=\"13\" />" + "</svg>" + "</button>";
        }
      });


      // init thumbnail img slider
      $('.jsc-thumbnails').owlCarousel('destroy');
      $('.jsc-thumbnails').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.jsc-mobile-slider-init',
        dots: true,
        centerMode: false,
        focusOnSelect: true,
        infinite: false
      });
    }
  }
}

desktopOnloadImgColor = () =>{
  if ($('.jsc-is-color').length) {
    var $selectedColor = $('.jsc-color-option:checked').val();
    var $imgContainer = $('.jsc-pdp-images');
    console.log($selectedColor,'Christmas is here');

    if (typeof $selectedColor !== 'undefined') {
      $imgContainer.hide();

      $imgContainer.each(function(){
        var $_this = $(this);
        var $_color = $_this.attr('data-alt');
        if ($_color.includes(",")) {
          $_color = $_color.split(",")[0];
        }
        if ($_color == $selectedColor || $_color == 'Main Image') {
          $_this.show();
        }
      });
    }
  }
}

onChangeImgColor = (e) =>{
  // Only the Color option uses jsc-color-option; other radios (e.g. size grid) pass
  // a size string and would hide all .jsc-pdp-images when compared to image alt text.
  if (!$(e).hasClass('jsc-color-option')) {
    return;
  }
  if ($(window).width() > 767) {
    desktopOnChangeImgColor(e);
  } else {
    mobileOnChangeImgColor(e);
  }

}

mobileOnChangeImgColor = (e) =>{
  if ($('.jsc-is-color').length) {
    var $this = $(e);
    var $selectedColor = $this.val();
    var $imgs = $('.jsc-hidden-media');

    if (typeof $selectedColor !== 'undefined') {

      // Destroy slick slider onchange
      $('.jsc-mobile-slider-init').slick('unslick');
      $('.jsc-thumbnails').slick('unslick');

      $('.jsc-mobile-slider-init').children().remove();
      $('.jsc-thumbnails').children().remove();

      $imgs.each(function(){
        var $_this = $(this);
        var $_color = $_this.attr('data-alt');
        var $_imgUrl = $_this.val();

        if ($_color.includes(",")) {
          $_color = $_color.split(",")[0];
        }
        if ($_color == $selectedColor || $_color == 'Main Image') {
          // Main Images
          var $html = '';
          $html = `<div class="slide">
            <a class="show-gallery" href="${$_imgUrl}">
              <div class="rimage-outer-wrapper">
                <img class="rimage__image lazyload fade-in"
                data-src="${$_imgUrl}"
                data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                data-aspectratio="1.0"
                data-sizes="auto"
                alt="${$_color}"
                >
              </div>
            </a>
          </div>`;

          $('.jsc-gallery__inner .product-slideshow').append($html);

          // Thumbnail Images
          var $thumbHtml = '';
          $thumbHtml = `<div class="jsc-thumbnail-wrapper relative">
              <img class="rimage__image lazyload fade-in"
              data-src="${$_imgUrl}"
              data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
              data-aspectratio="1.0"
              data-sizes="auto"
              alt="${$_color}"
              >
            </div>`;

          $('.jsc-mobile-image-wrapper .jsc-thumbnails').append($thumbHtml);
        }
      });

      // init main img slider
      // $('.jsc-mobile-slider-init').slick('unslick');

      $('.jsc-mobile-slider-init').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.jsc-thumbnails',
        infinite: false,
        dots: true,
        centerMode: false,
        focusOnSelect: true,
        customPaging: function customPaging(slider, i) {
          return "<button class=\"custom-dot\" type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\">" + "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" xml:space=\"preserve\">" + "<circle class=\"circle-one\" cx=\"15\" cy=\"15\" r=\"13\" />" + "<circle class=\"circle-two\" cx=\"15\" cy=\"15\" r=\"13\" />" + "</svg>" + "</button>";
        }
      });


      // init thumbnail img slider
      // $('.jsc-thumbnails').slick('unslick');
      $('.jsc-thumbnails').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.jsc-mobile-slider-init',
        dots: true,
        centerMode: false,
        focusOnSelect: true,
        infinite: false
      });
    }
  }
}

desktopOnChangeImgColor = (e) =>{
  if ($('.jsc-is-color').length) {
    var $this = $(e);
    var $selectedColor = $this.val();
    var $imgContainer = $('.jsc-pdp-images');

    $imgContainer.hide();

    $imgContainer.each(function(){
      var $_this = $(this);
      var $_color = $_this.attr('data-alt');

      if ($_color.includes(",")) {
        $_color = $_color.split(",")[0];
      }
      if ($_color == $selectedColor || $_color == 'Main Image') {
        $_this.show();
      }
    });
  }
}

zoomImgColor = (e, color) =>{
  var $selectedColor = $('.jsc-color-option:checked').val();

  if (typeof $selectedColor !== 'undefined') {
    if (color != $selectedColor && color != 'Main Image') {
      setTimeout(function(){
        e.remove();
      },150);
    }
  }
}

cartPopupFixes = (el) => {
  var $header = el.find('.cart-summary-overlay__row-head');
  var $html = '<h6>เพิ่มผลิตภัณฑ์ลงในรถเข็นสำเร็จแล้ว</h6>';

  $header.children().remove();

  $header.addClass('restyle-popup-cart').append($html);
  console.log('tryy333yyy',$header,$html);
}


formatString = (n) =>{
  var chars = n.substring(0,3);
  var xChar = n.substr(3).replace(/\D/g,'x');

  var newLastName = chars + xChar;

  return newLastName;
}
oneCardRemove = (e,cusId) => {
  var $this = $(e);
  var $loader = $('.jsc-loader-overlay');
  $loader.show();
  
  // Run Mechanic webhook
  let $data = {
    customerId: cusId
  };
  $.ajax({
    url: 'https://webhooks.mechanic.dev/e38e3b75-0d5d-405c-a942-2b31dbdaf176',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify($data)
  }).done(function () {
    $('#jsc-id-num').val('');
    $loader.hide();
    $this.hide();
    $('#jsc-one-card-success').show();
  });
}
const parseTagsFromLiveCustomerDocument = (doc) => {
  const el = doc.getElementById('LiveCustomerData');
  if (!el) return null;

  try {
    const data = JSON.parse(el.textContent.trim());
    return Array.isArray(data.tags) ? data.tags : [];
  } catch (error) {
    return null;
  }
};

const fetchLiveCustomerTags = async () => {
  try {
    const response = await fetch(window.location.pathname, { credentials: 'same-origin' });
    if (!response.ok) return null;
    const html = await response.text();
    if (!html.trim()) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return parseTagsFromLiveCustomerDocument(doc);
  } catch (error) {
    console.error('Failed to fetch live customer tags:', error);
    return null;
  }
};

const pollForOneCardTag = ($loader, $oneCardNo = '', intervalMs = 1500, timeoutMs = 20000) => {
  const start = Date.now();

  const interval = setInterval(async () => {
    const tags = await fetchLiveCustomerTags();
    console.log('pollForOneCardTag - tags',tags);

    if (tags === null) return;

    const isDone = tags.some((tag) => tag === `${$oneCardNo}_one_card_success` || tag.startsWith(`${$oneCardNo}_one_card_error_`));

    if (!isDone && Date.now() - start < timeoutMs) return;

    clearInterval(interval);
    $loader.hide();
    location.reload();
  }, intervalMs);
};
oneCardVerfication = (e, dT, cusId) =>{
  var $this = $(e);
  var $loader = $('.jsc-loader-overlay');
  var $oneCardNoEle = $('#jsc-id-num');
  var $oneCardNo = $oneCardNoEle.val();

  $loader.show();

  if ($oneCardNo != '') {
    $('#jsc-one-card-error').hide();
    let _data = {
      sourceTransID: `CMG_${cusId}_${dT}`,
      requestTime: dT,
      cardNo: $oneCardNo,
      customerId: cusId
    };
    $.ajax({
      url: 'https://webhooks.mechanic.dev/8e5d9d5c-8254-41f0-b31d-2cd9a919a6e7', // user/migrate/onecard
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify(_data)
    }).done(function () {
      setTimeout(function(){
        pollForOneCardTag($loader, $oneCardNo);
      },8000);
    });
  } else {
    $('#jsc-one-card-error').show();
    $('#jsc-one-card-ajax-error').hide();
    $('#jsc-one-card-success').hide();
    $loader.hide();
  }
}

removeOneCardError = () =>{
  var isTriggerRemoveTag = $('#trigger-remove-error').length;

  if (isTriggerRemoveTag) {
    var tag_val = $('#trigger-remove-error').val();
    var customer_id = $('#trigger-remove-error').attr('data-id');
    let _data = {
      tag: tag_val,
      customer_id: customer_id
    };
    $.ajax({
      url: 'https://webhooks.mechanic.dev/f8ccc8ae-228b-4e83-bddf-9426065db947', // user/migrate/onecard_remove_error
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify(_data)
    }).done(function () {
      
    });
  }
}

isInvoice = (e) =>{
  var $this = $(e);
  var $val = $this.val();
  var $html = `<p class="cart-attribute__field jsc-personal-company">
    <label class="fontWeight-9 line-height-2 ">คุณต้องการขอใบกำกับภาษีในนามบุคคลหรือนิติบุคคล</label><br>
    <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-personal-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Personal"> <label class="vertical-middle fontWeight-9 cursor p-r-25 inline m-b-0" for="jsc-personal-radio">ส่วนบุคคล</label>
    <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-company-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Company"> <label class="vertical-middle fontWeight-9 cursor inline m-b-0" for="jsc-company-radio">ในนามบริษัท</label><br>
  </p>`;

  if ($val == 'Yes') {
    $('.jsc-tax-invoice-inputs').append($html);
  } else {
    if ($('.jsc-personal-company').length) {
      $('.jsc-personal-company').remove();
    }
    if ($('.jsc-personal').length) {
      $('.jsc-personal').remove();
    }
    if ($('.jsc-company').length) {
      $('.jsc-company').remove();
    }
  }
}

isPersonalOrCompany = (e) =>{
  var $this = $(e);
  var $val = $this.val();

  if ($val == 'Personal') {
    var $html = `<div class="jsc-personal jsc-inputs-details">
      <p class="fontWeight-9 line-height-2">ส่วนบุคคล</p>
      <p class="cart-attribute__field relative m-b-20">
        <label class="Form__FloatingLabel opacity-1" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
        <input required class="required full-width" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="">
      </p>
      <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
      <span class="full-height text-center p-t-15 p-b-15 button" onclick="saveCartAttr(this)">บันทึกเพื่ออัปเดต</span>
    </div>`;
    $('.jsc-tax-invoice-inputs').append($html);
    if ($('.jsc-company').length) {
      $('.jsc-company').remove();
    }
  } else {
    var $html = `<div class="jsc-company jsc-inputs-details">
      <p class="fontWeight-9 line-height-2">ในนามบริษัท</p>
      <p class="cart-attribute__field relative m-b-30">
        <label class="Form__FloatingLabel opacity-1" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
        <input required class="required full-width" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="">
      </p>
      <p class="cart-attribute__field relative m-b-30">
        <label class="Form__FloatingLabel opacity-1" for="company-name">ชื่อบริษัท<span style="color: red;"> *</span></label>
        <input required class="required full-width" id="company-name" type="text" name="attributes[company]" value="">
      </p>
      <p class="cart-attribute__field relative m-b-30">
        <label class="Form__FloatingLabel opacity-1" for="branch-type">ประเภทของสำนักงาน<span style="color: red;"> *</span></label>
        <select onchange="onChangeBType(this)" required class="required full-width" id="branch-type" name="attributes[Branch Type]" style="padding: 12px; border-color: #c5c5c5;">
          <option value="Headquarter">สำนักงานใหญ่</option>
          <option value="Branch">สาขา</option>
        </select>
      </p>
      <p class="cart-attribute__field relative m-b-20">
        <label class="Form__FloatingLabel opacity-1" for="branch-id">รหัสสาขา<span style="color: red;"> *</span></label>
        <input required class="required full-width" id="branch-id" type="text" maxlength="5" name="attributes[branch_id]" value="00000">
        <span id="jsc-b-id-overlay"></span>
      </p>
      <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
      <span class="full-height text-center p-t-15 p-b-15 button" onclick="saveCartAttr(this)">บันทึกเพื่ออัปเดต</span>
    </div>`;
    $('.jsc-tax-invoice-inputs').append($html);
    if ($('.jsc-personal').length) {
      $('.jsc-personal').remove();
    }
  }
}

saveCartAttr = (e) =>{
  var $this = $(e);
  var $inputs = $this.parents('.jsc-inputs-details').find('input');
  var isFilled = true;

  $inputs.each(function(){
    var $_this = $(this);
    var $_val = $_this.val();
    console.log('dddd',$_val);

    if (!$_val) {
      isFilled = false;
    }
  });

  if (isFilled) {
    $('#jsc-required-text').hide();
    $this.text('บันทึกเสร็จแล้ว!');
    cartJSSaveAttr();
  } else {
    $('#jsc-required-text').show();
    $this.text('บันทึกเพื่ออัปเดต');
  }
}

cartJSSaveAttr = () =>{
  var input_elements = $('.jsc-tax-invoice').find('input');
  var dataObject = {};
  var isPersonal = false;

  input_elements.each(function() {
    var inputType = $(this).attr('type');
    var inputName = $(this).attr('name');
    var inputValue;

    if (inputType === 'text') {
      // For text inputs, capture the value directly
      inputValue = $(this).val();
    } else if (inputType === 'radio' && $(this).is(':checked')) {
      // For radio inputs, capture the value only if it's checked
      inputValue = $(this).val();
      if ($(this).val() == 'Personal') {
        isPersonal = true;
      }
    }

    // Extract the value inside the square brackets
    var matches = inputName.match(/\[([^\]]+)\]/);
    var key = matches ? matches[1] : null;

    if (isPersonal) {
      dataObject['company'] = 'N/A';
      dataObject['branch_id'] = 'N/A';
    }

    // Add the data to the object if name and value are defined
    if (inputName && inputValue !== undefined) {
      dataObject[key] = inputValue;
    }
  });

  // set attribute
  CartJS.setAttributes(dataObject);
}

getTaxAttr = () =>{
  
  $.getJSON('/cart.js', function(cart) {
    var cart_attr_obj = cart.attributes;
    console.log('ujuj',cart_attr_obj);
    if (cart_attr_obj.isFullTax) {
      $(`#jsc-${cart_attr_obj.isFullTax.toLowerCase()}-radio`).click();
    }
    if (cart_attr_obj['Are you a Personal or Company (Individual Company)']) {
      $(`#jsc-${cart_attr_obj['Are you a Personal or Company (Individual Company)'].toLowerCase()}-radio`).click();
    }
    if ($('#tax-id').length != 0) {
      $('#tax-id').val(cart_attr_obj.vat_id);
    }
    if ($('#company-name').length != 0) {
      $('#company-name').val(cart_attr_obj.company);
    }
    if ($('#branch-id').length != 0) {
      $('#branch-id').val(cart_attr_obj.branch_id);
    }
  });
  
}

onChangeBType = (e) => {
  var $this = $(e);
  var $val = $this.val();

  if ($val == 'Headquarter') {
    $('#jsc-b-id-overlay').show();
    $('#branch-id').val('00000');
  } else {
    $('#jsc-b-id-overlay').hide();
    $('#branch-id').val('');
  }
}

$(document).ready(function() {
  var currentURL = window.location.href;
  var productHandle = getProductHandle(currentURL);
  console.log('productHandle: ', productHandle);
  if (productHandle && !currentURL.includes("variant=")) {
    findVariantID(productHandle);
  }
});

function getProductHandle(url) {
  var match = url.match(/\/products\/([^?#]+)/);
  if (match) {
      return match[1];
  } else {
      return null;
  }
}

function findVariantID(productHandle) {
  var productURL = window.Shopify.routes.root + 'products/' + productHandle + '.js';

  fetch(productURL)
    .then(response => response.json())
    .then(product => {
        // console.log("product: ", product);
        if (product.variants && product.variants.length > 0) {
            var variantId = product.variants[0].id;
            if (variantId) {
              updateURL(variantId);
            }
        }
    })
    .catch(error => {
        console.error("Error fetching product data:", error);
    });
}

function updateURL(variantID) {
  var currentURL = window.location.href;
  var newURL;

  if (currentURL.includes("?")) {
      newURL = currentURL + "&variant=" + variantID;
  } else {
      newURL = currentURL + "?variant=" + variantID;
  }

  console.log('newURL: ', newURL);
  window.location.href = newURL;
}


openChat = (e) => {
  var $this = $(e);
  $('#lisa-open-button').click();
}

openChatFromPageFly = () =>{
  $('.jsc-open-chat').click(function(){
    $('#lisa-open-button').click();
  });
}

initFeatrueCollectionSlider = () => {
  console.log('initFeatrueCollectionSlider');
  var flkty = $('.featured-collection-slider').flickity({
    cellAlign: 'left',
    freeScroll: true,
    wrapAround: true,
    adaptiveHeight: true,
    prevNextButtons: true,
    pageDots: true,
    resize: true
  });

  setTimeout(() => {
    flkty.resize();
  }, 100);
}

// start: Product image - Gallery modal
$('#gallery-media-modal-btn').click(function() {
  const productId = $(this).attr('data-product-id');
  const modal = $(`#gallery-media-modal-${productId}`);

  if (modal) {
    modal.css('display', 'block');
    $('body').addClass('no-scroll');
    initGalleryModal(modal, productId);
  }
});

initGalleryModal = (modal, productId) => {
  const mainFlickityEl = `#gallery-media-modal-${productId} .main-gallery-flickity`;
  const mainThumbEl = `#gallery-media-modal-${productId} .thumb-gallery-flickity`;

  // const tabs = $(modal).find('.tab-container [data-tab]');
  const mainFlickity = $(modal).find('.main-gallery-flickity');
  const mainThumbnail =  $(modal).find('.thumb-gallery-flickity');

  console.log('productId: ', productId)
  if (localStorage.getItem('productId') !== productId) {
      if (mainThumbnail) {
          const clonedThumbnail = mainThumbnail.clone();
          localStorage.setItem('clonedThumbnail', clonedThumbnail[0].outerHTML);
      }
      if (mainFlickity) {
          const clonedFlickity = mainFlickity.clone();
          localStorage.setItem('clonedFlickity', clonedFlickity[0].outerHTML);
      }
      localStorage.setItem('productId', productId);
  }

  initGalleryFlickity(mainFlickityEl, mainThumbEl);
  prepareVideo(modal);
  // init gallery modal tab
  // if (tabs) {
  //   $(tabs).each((index, tab) => {
  //         $(tab).click(() => {
  //             const tabName = $(this).attr('data-tab');

  //             /* start: active tab color */
  //             $(tabs).each((index, sibling) => {
  //               $(sibling).removeClass('is-active');
  //             });

  //             $(tab).addClass('is-active');
  //             /* end: active tab color */

  //             /* start: destroy flickity */
  //             if ($(mainFlickityEl).data('flickity')) {
  //                 $(mainFlickityEl).data('flickity').destroy();
  //                 console.log('mainFlickityEl destroy: ', $(mainFlickityEl));
  //             }
  //             if ($(mainThumbEl).data('flickity')) {
  //               $(mainThumbEl).data('flickity').destroy();
  //               console.log('mainThumbEl destroy: ', $(mainThumbEl));
  //             }
  //             /* end: destroy flickity */

  //             /* start: clone main product media flickity */
  //             var galleryModalFlickity = $(modal).find(`.main-gallery-flickity`);

  //             if (galleryModalFlickity) {
  //                 clonedFlickity('clonedFlickity', tabName, galleryModalFlickity, 'product-media-wrapper');
  //             }
  //             /* end: clone main product media flickity */

  //             /* start: clone thumbnail flickity */
  //             var thumbnailFlickity = $(modal).find(`.thumb-gallery-flickity`);

  //             if (thumbnailFlickity) {
  //                 clonedFlickity('clonedThumbnail', tabName, thumbnailFlickity, 'product-media-wrapper');
  //             }
  //             /* end: clone thumbnail media flickity */

  //             initGalleryFlickity(mainFlickityEl, mainThumbEl);
  //         })
  //     })
  // }
}

// start: prepareVideo
prepareVideo = (modal) => {
  console.log('prepareVideo: ', modal);
  $(modal).find('.product-media--video').each(function (index) {
    var poster = this.querySelector('.product-media__poster');

    var playerObj = { container: this, poster: poster };
    playerObj.play = function () {
      // init
      var template = this.container.querySelector('template');
      if (template) {
        this.container.appendChild(template.content);
        this.container.removeChild(template);
        this.container.style.paddingBottom = 100 / this.container.querySelector('video, iframe').getAttribute('aspect-ratio') + '%';
        $(this.container).closest('.slick-slider').slick('refresh');
      }

      // hide poster
      this.poster.classList.add('product-media__poster--hide');

      // play
      this.container.querySelectorAll('.js-youtube').forEach(video => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
      });
      this.container.querySelectorAll('.js-vimeo').forEach(video => {
        video.contentWindow.postMessage('{"method":"play"}', '*');
      });
      this.container.querySelectorAll('video').forEach(video => video.play());
    }.bind(playerObj);

    playerObj.pause = function () {
      theme.pauseAllMedia();
    };

    $(this).data('player', playerObj).addClass('product-media--video-loaded');

    $('.product-media__video-play-btn', poster).on('click', function () {
      $(this).closest('.product-media--video').data('player').play();
    }).click();
  });
}
// end: prepareVideo

// start: Init flickity
initGalleryFlickity = (main, thumb) => {
  if (main != '') {
    var $mainSlider = $(main).flickity({
      cellAlign: 'center',
      contain: true,
      adaptiveHeight: true,
      prevNextButtons: true,
      pageDots: false,
      resize: true,
      wrapAround: true
    });
    console.log('mainSlider: ', $mainSlider);
  }

  if (thumb != '') {
    var $thumbSlider = $(thumb).flickity({
      cellAlign: 'center',
      asNavFor: main,
      contain: true,
      adaptiveHeight: true,
      prevNextButtons: false,
      pageDots: false,
      resize: true
    });
    console.log('thumbSlider: ', $thumbSlider);
  }

  setTimeout(() => {
    if (main != '') {$mainSlider.resize()};
    if (thumb != '') {$thumbSlider.resize()};
  }, 100);
}
// end: Init flickity

clonedFlickity = (name, tabName, flickityContainer, slideClass) => {
  console.log('clonedFlickity: ', name);
  const storedElementHTML = localStorage.getItem(name);
  const tempDiv = $('<div></div>');
  $(tempDiv).html($(storedElementHTML));
  console.log('tempDiv: ', tempDiv);

  const retrievedElement = tempDiv[0].firstChild;
  $(retrievedElement).addClass(name);
  console.log('retrievedElement: ', $(retrievedElement));

  const slideElement = $(retrievedElement).find(`.${slideClass}`);
  console.log('slideElement: ', slideElement);

  let currentThumbnailIndex = -1;
  $(slideElement).each((index, slide) => {
    console.log('slide: ', slide);
      if (tabName == 'image' && $(slide).attr('data-type') !== 'image') {
          $(slide).remove();
      } else if (tabName == 'video' && $(slide).attr('data-type') !== 'video'){
          $(slide).remove();
      } else if (name == 'clonedThumbnail') {
          currentThumbnailIndex += 1
          $(slide).attr('data-index', currentThumbnailIndex);
      }
  })

  console.log('retrievedElement AFTER: ', $(retrievedElement));
  $(retrievedElement).insertBefore(flickityContainer);
  $(flickityContainer).remove();
  $(retrievedElement).removeClass(name);
}
// end: Product image - Gallery modal

// start: product highlights
initPdpHighlightSlider = () => {
  var $slider = $('.jsc-product-highlight-wrapper').find('.jsc-product-highlight');
  if($slider.length > 0) {
      $slider.flickity({
          prevNextButtons: false,
          pageDots: false,
          cellAlign: 'left',
          contain: true,
          wrapAround: false
      });
  }
}

playVideoInSequence = () => {
  var currentIndex = 0;
  var $videos = $('.jsc-product-highlight .jsc-product-highlight-media').find('video.jsc-highlight-media-thumbnail');

  if($videos.length > 0) {
      $videos[currentIndex].play();

      $videos.each(function(index, video) {
          $(video).on('ended', function() {
              if(currentIndex < $videos.length - 1) {
                  currentIndex ++;
                  $videos[currentIndex].play();
              }
          })
      });
  }
}

showHighlightPopup = (evt) => {
  var index = $(evt).find('.jsc-highlight-media-thumbnail').attr('data-index');
  var $popup = $('.jsc-product-highlight-popup[data-index="' + index + '"]');
  if($('video.jsc-highlight-media-full').length > 0) {
    $('video.jsc-highlight-media-full')[0].pause();
  }

  if($popup.length > 0) {
      var $allPopup = $('.jsc-product-highlight-popup');
      $allPopup.removeClass('active');
      $popup.find('.jsc-highlight-media-full')[0].currentTime = 0;
      $popup.addClass('active');
      $('#jsc-custom-chat-widget').addClass('hide-important');
      $popup.find('.jsc-highlight-media-full')[0].play();
  }
}

updateHighlightPopupPosition = () => {
  var $container = $('#main .container');
  if($(window).width() > 1024 && $container.length > 0) {
      var containerRight = $('#main .container')[0].getBoundingClientRect().right;
      var containerPadding = parseInt($('#main .container').css('padding-right'));
      var windowWidth = $(window).width();
      if(containerRight < windowWidth) {
          var rightPos = windowWidth - containerRight + containerPadding;
          $('.jsc-product-highlight-popup').css('right', rightPos + 'px');
      }
  }
  
}

hideHighlightPopup = (evt) => {
  var $popup = $(evt).parent();
  $popup.removeClass('active');
  var popupvideo = $(evt).parents('.jsc-product-highlight-popup');
  if(popupvideo.length > 0) {
    popupvideo.find('.jsc-highlight-media-full')[0].pause();
  }
  $('#jsc-custom-chat-widget').removeClass('hide-important');
}
// end: product highlights